import React, {useEffect, useState} from "react";
import axiApi from "ApiCaller";
import {useNavigate} from "react-router-dom";
import NavBreadcrumb from "../../components/NavBreadcrum";
import {useTranslation} from "react-i18next";
import navs from "./navs";
import moment from "moment";

const DocumentationList = () => {
    const [documents, setDocuments] = useState([]);
    const [documentLines, setDocumentLines] = useState([]);
    const navigate = useNavigate();
    const {t: _tR} = useTranslation("routes");
    const {t: _tT} = useTranslation("tables");

    const title = _tR("labels.documentation");
    document.title = title;

    const bread = [
        {
            name: _tR("labels.documentation"),
            url: "/documentation/",
            current: true,
        },
    ];

    useEffect(() => {
        axiApi
            .get("/api/loggers/documentation/")
            .then((resp) => {
                // console.log(resp.data);
                setDocuments(resp.data.items.documents);
            })
            .catch((err) => {
                console.error("Error fetching releases:", err);
            });
    }, []);

    const handleNavigation = (e, version) => {
        e.preventDefault();
        navigate(`/documentation/${version}/`);
    };

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread}></NavBreadcrumb>

            <div className="mt-4">
                <h3 className="mb-4">{_tR("labels.documentation-list")}</h3>
                <table className="table ">
                    <tbody>
                        {documents.map((doc) => (
                            <tr key={doc.id}>
                                <td
                                    style={{width: "5%", cursor: "pointer"}}
                                    className="text-center text-primary"
                                    onClick={(e) => handleNavigation(e, doc.version)}>
                                    <strong>{doc.version}</strong>
                                </td>
                                <td className="text-muted">
                                    {moment(doc.created_at).format("MMMM D, YYYY")}
                                </td>
                                <td className="text-end">
                                    <a
                                        href={`/documentation/${doc.version}/`}
                                        onClick={(e) =>
                                            handleNavigation(e, doc.version)
                                        }>
                                        {_tT("labels.notes")}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default DocumentationList;
